
import axios from 'axios'


const eventosApi = axios.create({
    baseURL: 'https://api360.360margaritaca.com.ve'
    // baseURL: 'https://api360.360margaritaca.com.ve',
})
eventosApi.interceptors.request.use((config) => {

    config.headers = {
        Authorization: `Bearer ${localStorage.getItem('api_token')}`,
        Accept: "application/json",
        "Content-Type": "application/json",
        responseType: "json",
    }
    return config
})

export default eventosApi


